import { defaultSoundPreferences } from '@/features/notifications/notification-service-extension-shared'
import { NotificationType } from '@/features/notifications/notification-service-extension-shared/constants/firebase'
import { Form } from '@/features/settings/components/NotificationConfiguration/form/types'
import {
    NotificationPreferences,
    NotificationSettings,
    NotificationSoundPreferences,
} from '@/features/settings/types'

const soundPreferenceKeys = {
    [NotificationType.AwaitingAcceptanceOrder]: `${NotificationType.AwaitingAcceptanceOrder}.sound`,
    [NotificationType.AcceptedOrder]: `${NotificationType.AcceptedOrder}.sound`,
} as const

const enabledPreferenceKeys = {
    [NotificationType.AwaitingAcceptanceOrder]: `${NotificationType.AwaitingAcceptanceOrder}.enabled`,
    [NotificationType.AcceptedOrder]: `${NotificationType.AcceptedOrder}.enabled`,
} as const

export const mapSettingsToFormValues = (settings: NotificationSettings): Form => ({
    orderAccepted: {
        enabled: settings[enabledPreferenceKeys[NotificationType.AcceptedOrder]],
        sound: settings[soundPreferenceKeys[NotificationType.AcceptedOrder]],
    },
    orderAwaitingAcceptance: {
        enabled: settings[enabledPreferenceKeys[NotificationType.AwaitingAcceptanceOrder]],
        sound: settings[soundPreferenceKeys[NotificationType.AwaitingAcceptanceOrder]],
    },
})

export const mapFormValuesToSettings = (form: Form): NotificationSettings => ({
    [enabledPreferenceKeys[NotificationType.AcceptedOrder]]: form.orderAccepted.enabled,
    [soundPreferenceKeys[NotificationType.AcceptedOrder]]: form.orderAccepted.sound,
    [enabledPreferenceKeys[NotificationType.AwaitingAcceptanceOrder]]:
        form.orderAwaitingAcceptance.enabled,
    [soundPreferenceKeys[NotificationType.AwaitingAcceptanceOrder]]:
        form.orderAwaitingAcceptance.sound,
})

export const mapPreferencesToSettings = (
    notificationPrefs: NotificationPreferences,
    soundPrefs: NotificationSoundPreferences
): NotificationSettings => {
    return {
        [enabledPreferenceKeys[NotificationType.AcceptedOrder]]:
            notificationPrefs[NotificationType.AcceptedOrder],
        [enabledPreferenceKeys[NotificationType.AwaitingAcceptanceOrder]]:
            notificationPrefs[NotificationType.AwaitingAcceptanceOrder],
        [soundPreferenceKeys[NotificationType.AcceptedOrder]]:
            soundPrefs[NotificationType.AcceptedOrder] ??
            defaultSoundPreferences[NotificationType.AcceptedOrder] ??
            true,
        [soundPreferenceKeys[NotificationType.AwaitingAcceptanceOrder]]:
            soundPrefs[NotificationType.AwaitingAcceptanceOrder] ??
            defaultSoundPreferences[NotificationType.AwaitingAcceptanceOrder] ??
            true,
    }
}

export const mapSettingsToNotificationPreferences = (
    settings: NotificationSettings
): NotificationPreferences => ({
    [NotificationType.AcceptedOrder]:
        settings[enabledPreferenceKeys[NotificationType.AcceptedOrder]],
    [NotificationType.AwaitingAcceptanceOrder]:
        settings[enabledPreferenceKeys[NotificationType.AwaitingAcceptanceOrder]],
})

export const mapSettingsToSoundPreferences = (
    settings: NotificationSettings
): NotificationSoundPreferences => ({
    [NotificationType.AcceptedOrder]: settings[soundPreferenceKeys[NotificationType.AcceptedOrder]],
    [NotificationType.AwaitingAcceptanceOrder]:
        settings[soundPreferenceKeys[NotificationType.AwaitingAcceptanceOrder]],
})
